function unwrapSmallBikeShopifyBlockWrappers(wrapperEl) {
  Array.prototype.slice.call(wrapperEl.children).forEach(function (child) {
    if (child.classList && child.classList.contains('shopify-block')) {
      while (child.firstChild) {
        wrapperEl.insertBefore(child.firstChild, child);
      }
      wrapperEl.removeChild(child);
    }
  });
}

function initNewLandingSmallBikeSlider(root) {
  if (typeof Swiper === 'undefined') return;

  var scope = root && root.querySelectorAll ? root : document;
  var groups = scope.querySelectorAll('.new-landing-small-bike-slider__group');

  groups.forEach(function (group) {
    if (group.dataset.bikeSliderInitialized) return;
    group.dataset.bikeSliderInitialized = 'true';

    var stageEl = group.querySelector('[data-bike-stage]');
    var wrapperEl = stageEl ? stageEl.querySelector('.swiper-wrapper') : null;
    var swatchesContainer = group.querySelector('[data-bike-swatches]');
    var prevEl = group.querySelector('[data-bike-prev]');
    var nextEl = group.querySelector('[data-bike-next]');

    if (!stageEl || !wrapperEl) return;

    unwrapSmallBikeShopifyBlockWrappers(wrapperEl);

    var realSlideKeys = Array.prototype.map.call(wrapperEl.querySelectorAll('.swiper-slide'), function (el) {
      return el.dataset.slideKey;
    });

    var swatches = group.querySelectorAll('[data-slide-swatch]');
    if (swatchesContainer) {
      swatches.forEach(function (btn) {
        swatchesContainer.appendChild(btn);
      });
    }

    var swiper = new Swiper(stageEl, {
      slidesPerView: 1,
      autoHeight: true,
      speed: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 600,
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl,
      },
    });

    wrapperEl.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () {
        swiper.updateAutoHeight();
      });
    });

    var currentBgImage = '';
    var requestedBgImage = '';
    var backgroundBusy = false;
    var backgroundImages = {};
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var bgContainer = group.querySelector('.new-landing-small-bike-slider__background');
    var fadeEl = group.querySelector('[data-bg-fade]');
    var bgEl = bgContainer && bgContainer.querySelector('.new-landing-small-bike-slider__bg-image');

    function preloadBackground(url) {
      if (!backgroundImages[url]) {
        backgroundImages[url] = new Promise(function (resolve) {
          var image = new Image();
          image.onload = function () {
            if (image.decode) image.decode().catch(function () {}).then(function () { resolve(true); });
            else resolve(true);
          };
          image.onerror = function () { resolve(false); };
          image.src = url;
        });
      }
      return backgroundImages[url];
    }

    wrapperEl.querySelectorAll('[data-bg-image]').forEach(function (slide) {
      preloadBackground(slide.getAttribute('data-bg-image'));
    });

    function renderBackground() {
      if (backgroundBusy || !requestedBgImage || requestedBgImage === currentBgImage || !bgContainer || !fadeEl) return;
      var url = requestedBgImage;
      backgroundBusy = true;
      preloadBackground(url).then(function (loaded) {
        if (!loaded || url !== requestedBgImage || swiper.destroyed) {
          backgroundBusy = false;
          if (url !== requestedBgImage && !swiper.destroyed) renderBackground();
          return;
        }
        if (!bgEl) {
          bgEl = document.createElement('img');
          bgEl.className = 'new-landing-small-bike-slider__bg-image';
          bgEl.alt = '';
          bgContainer.insertBefore(bgEl, bgContainer.firstChild);
        }
        // Set the initial color directly, then crossfade every navigation source identically.
        if (!currentBgImage || reducedMotion) {
          bgEl.src = url;
          currentBgImage = url;
          backgroundBusy = false;
          return;
        }
        fadeEl.style.transition = 'none';
        fadeEl.style.opacity = '0';
        fadeEl.src = url;
        fadeEl.offsetHeight;
        fadeEl.style.transition = '';
        var finished = false;
        var fallback;
        function finish(event) {
          if (event && (event.target !== fadeEl || event.propertyName !== 'opacity')) return;
          if (finished) return;
          finished = true;
          clearTimeout(fallback);
          fadeEl.removeEventListener('transitionend', finish);
          bgEl.src = url;
          currentBgImage = url;
          fadeEl.style.transition = 'none';
          fadeEl.style.opacity = '0';
          fadeEl.offsetHeight;
          fadeEl.style.transition = '';
          backgroundBusy = false;
          renderBackground();
        }
        fadeEl.addEventListener('transitionend', finish);
        requestAnimationFrame(function () {
          if (swiper.destroyed) { backgroundBusy = false; fadeEl.removeEventListener('transitionend', finish); return; }
          fadeEl.style.opacity = '1';
          fallback = setTimeout(finish, 700);
        });
      });
    }

    function crossfadeBackgroundImage(url) {
      if (!url) return;
      requestedBgImage = url;
      renderBackground();
    }

    function updateActiveState() {
      var activeSlide = swiper.slides[swiper.activeIndex];
      var key = activeSlide ? activeSlide.dataset.slideKey : null;
      var currentNameEl = group.querySelector('[data-active-bike-name]');

      swatches.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.dataset.slideKey === key);
      });

      if (currentNameEl) {
        currentNameEl.textContent = activeSlide ? activeSlide.getAttribute('data-bike-name') || '' : '';
      }

      var bgImageUrl = activeSlide ? activeSlide.getAttribute('data-bg-image') : '';
      crossfadeBackgroundImage(bgImageUrl);
    }

    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = realSlideKeys.indexOf(btn.dataset.slideKey);
        if (index !== -1) swiper.slideTo(index);
      });
    });

    swiper.on('slideChange', updateActiveState);
    updateActiveState();
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initNewLandingSmallBikeSlider(document);
});

document.addEventListener('shopify:section:load', function (event) {
  initNewLandingSmallBikeSlider(event.target);
});

if (document.readyState === 'complete' || document.readyState === 'interactive') {
  initNewLandingSmallBikeSlider(document);
}
